import React, {
  Dispatch,
  MutableRefObject,
  SetStateAction,
  useState,
} from 'react';
import styled, { css } from 'styled-components';

import TimeIcon from '@/assets/svg/time.svg';
import { useTypedSelector } from '@/store/store';
import { selectOfflineValuationUserChoice } from '@/store/reducers/offline-valuation-user-data';
import { OfflineCheckedValuesModel } from '@/modules/ValueCar/components/OfflineValuation/components/ContactFormOfflineValuation/interfaces';
import TextInput from '@/components/TextInput';
import { media } from '@/utils/mixin';
import { colors } from '@/constants/theme';

import TimePicker from './component/TimePicker';

interface Props {
  timeRef: MutableRefObject<HTMLDivElement | null>;
  checkedValues?: OfflineCheckedValuesModel;
  setCheckedValues?: Dispatch<SetStateAction<OfflineCheckedValuesModel>>;
  isChecked?: boolean;
  isShowTimePicker: boolean;
  setIsShowTimePicker: Dispatch<SetStateAction<boolean>>;
}

function TimeComponent({
  timeRef,
  setCheckedValues,
  checkedValues,
  isChecked,
  isShowTimePicker,
  setIsShowTimePicker,
}: Props) {
  const chosenData = useTypedSelector(selectOfflineValuationUserChoice);
  const [isShowEmptyMessage, setIsShowEmptyMessage] = useState(false);

  return (
    <Component ref={timeRef} isChecked={isChecked}>
      <TextInput
        label="Время"
        value={chosenData.time}
        badge={<TimeIcon />}
        onClick={() => {
          setIsShowEmptyMessage(false);
          setIsShowTimePicker(!isShowTimePicker);
        }}
      />
      {isShowTimePicker && (
        <TimePicker
          chosenData={chosenData}
          setIsShowTimePicker={setIsShowTimePicker}
          onClick={() => setIsShowTimePicker(false)}
          onClose={() => setIsShowTimePicker(false)}
          isShowEmptyMessage={isShowEmptyMessage}
          setIsShowEmptyMessage={setIsShowEmptyMessage}
          setCheckedValues={setCheckedValues}
          checkedValues={checkedValues}
        />
      )}
    </Component>
  );
}

export default TimeComponent;

const Component = styled.div<{ isChecked?: boolean }>`
  width: 384px;
  position: relative;

  ${({ isChecked }) =>
    !isChecked &&
    css`
      input {
        border: 1px solid ${colors.red700};
        background: ${(props) => props.theme.red_1};
      }
    `};

  ${media.mobile(
    css`
      width: 100%;
      margin-top: 35px;
    `
  )}
`;
